import React from "react";
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    CartesianGrid,
    Legend,
    ResponsiveContainer
} from "recharts";
import { Box, Typography, Paper } from "@mui/material";

const EngagementChart = ({ data }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                borderRadius: 4,
                backgroundColor: "#ffffff",
                boxShadow: "0 20px 50px rgba(0,0,0,0.08)"
            }}
        >
            <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                Engagement Chart
            </Typography>

            <Box sx={{ width: "100%", height: 420 }}>
                <ResponsiveContainer width="100%" height="100%">
                    <LineChart
                        data={data}
                        margin={{ top: 20, right: 40, left: 20, bottom: 40 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis
                            dataKey="month"
                            tick={{ fontSize: 12 }}
                            angle={-35}
                            textAnchor="end"
                        />
                        <YAxis />
                        <Tooltip />
                        <Legend verticalAlign="top" height={36} />

                        <Line type="monotone" dataKey="likes" stroke="#8884d8" strokeWidth={3} dot={{ r: 4 }} />
                        <Line type="monotone" dataKey="comments" stroke="#82ca9d" strokeWidth={3} dot={{ r: 4 }} />
                        <Line type="monotone" dataKey="shares" stroke="#ffc658" strokeWidth={3} dot={{ r: 4 }} />
                        <Line type="monotone" dataKey="clicks" stroke="#ff7300" strokeWidth={3} dot={{ r: 4 }} />
                    </LineChart>
                </ResponsiveContainer>
            </Box>
        </Paper>
    );
};

export default EngagementChart;